import React from 'react';
import { Section } from './Section';
import { AlertTriangle } from 'lucide-react';
const pains = ['Llegás al entrenamiento sin saber exactamente qué ejercicio vas a dar hoy', 'Tus jugadoras no progresan porque no tenés una secuencia clara de nivel a nivel', 'El 40% de tus jugadoras abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Correcciones improvisadas, sin un método claro que te respalde', 'Jugadoras de distintos niveles juntas y el entrenamiento se convierte en un caos', 'Fin de mes y las jugadoras se van sin avisar porque la comunicación es inconsistente'];
export function PainPoints() {
  return <Section data-id="element-219">
      <div className="max-w-4xl mx-auto" data-id="element-220">
        <div className="text-center mb-6 md:mb-12" data-id="element-221">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-2 md:mb-4" data-id="element-222">
            Si sos profe de volley en Argentina, esto te va a sonar familiar:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-8 md:mb-12" data-id="element-223">
          {pains.map((pain, index) => <div key={index} className="flex items-start gap-3 md:gap-4 bg-navy-900 p-3 md:p-5 rounded-xl border border-red-900/30 hover:border-red-500/50 transition-colors" data-id="element-224">
              <div className="flex-shrink-0 w-6 h-6 md:w-8 md:h-8 rounded-full bg-red-500/10 flex items-center justify-center text-red-400 font-bold font-heading text-xs md:text-sm" data-id="element-225">
                {(index + 1).toString().padStart(2, '0')}
              </div>
              <p className="text-gray-300 text-xs md:text-base leading-relaxed" data-id="element-226">
                {pain}
              </p>
            </div>)}
        </div>

        <div className="text-center bg-red-500/10 border border-red-500/20 rounded-xl md:rounded-2xl p-4 md:p-8" data-id="element-227">
          <AlertTriangle className="w-8 h-8 md:w-12 md:h-12 text-red-400 mx-auto mb-2 md:mb-4" data-id="element-228" />
          <h3 className="text-xl md:text-3xl font-heading font-bold text-white" data-id="element-229">
            ¿Cuántos entrenamientos más vas a improvisar?
          </h3>
        </div>
      </div>
    </Section>;
}